function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v113.775H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M0 312.888h512v113.775H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 256.006L0 426.668V85.331zm49.716-.006c0-19.892 13.98-36.51 32.649-40.587a41.66 41.66 0 00-8.904-.966c-22.95 0-41.553 18.603-41.553 41.553s18.603 41.553 41.553 41.553c3.058 0 6.035-.339 8.904-.966-18.669-4.077-32.649-20.695-32.649-40.587z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M340.112 229.287l5.894 18.14h19.072l-15.43 11.211 5.894 18.139-15.43-11.21-15.431 11.21 5.895-18.139-15.431-11.211h19.072z"
}));

const SvgSahrawiArabDemocraticRepublic = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSahrawiArabDemocraticRepublic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sahrawi-arab-democratic-republic.ab232dea.svg";
export { ForwardRef as ReactComponent };